import { render } from "./IndexedParagraph.vue?vue&type=template&id=ea757e6e"
import script from "./IndexedParagraph.vue?vue&type=script&lang=js"
export * from "./IndexedParagraph.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__